import client from './services/auth-client'

/* eslint-disable */
export const auth = {
    namespaced:true,
    state: {
        connectedUser:undefined,
        verification_errors:{},
        submittinglogin:false,
    },
    mutations: {
        SET_CONNECTED_USER(state,user){
            state.connectedUser = user
        },
        SET_COUNTRIES(state,countries){
            state.countries = countries
        },
        SET_SUBMIT(state,countries){
            state.submittinglogin = countries
        },
        SET_VERIFICATION_ERROR(state,data){
            state.verification_errors.error = (data.error)?'error':'success';
            state.verification_errors.message = data.message
        }
    },
    actions: {
        register({commit},data) {
            //data.forEach((value,key) => {
            //    window.console.log(key+' ===> '+value)
            //});
            let url = 'register';
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: url,
                    data:data,
                }).then((response) => {
                    resolve(response.data)
                }).catch((error) => {
                    reject(error)
                })
            })
        },
        login({commit},data) {
            commit('SET_SUBMIT',true);
            let url = 'login';
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: url,
                    data:data
                }).then((response) => {
                    if (!response.data.error){
                        commit('SET_CONNECTED_USER',response.data.user);
                        localStorage.setItem("user",JSON.stringify(response.data.user));
                        localStorage.setItem("token",response.data.token);
                        localStorage.setItem("mineroles",JSON.stringify(response.data.roleusers));
                    }
                    commit('SET_SUBMIT',false);

                    console.log("response",response);

                    resolve(response.data)
                }).catch((error) => {
                    reject(error)
                })
            })
        },
        sendResetMail({commit},data) {
            let url = 'password/reset';
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: url,data:data
                }).then((response) => {
                    resolve(response.data)
                }).catch((error) => {
                    reject(error)
                })
            })
        },
        resetPassword({commit},data) {
            let url = 'password/reset/'+data.route.id+'/'+data.route.token;
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: url,data:data.form
                }).then((response) => {
                    resolve(response.data)
                }).catch((error) => {
                    reject(error)
                })
            })
        },
        logout({commit}) {
            let url = 'logout';
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: url
                }).then((response) => {
                    if (!response.data.error)
                        commit('SET_CONNECTED_USER',undefined);
                    localStorage.clear();
                    resolve(response.data)
                }).catch((error) => {
                    reject(error)
                })
            })
        },
        getCountries({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/register/countries',
                })
                    .then((response)=>{
                        commit('SET_COUNTRIES',response.data.countries)
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        verify({commit},token) {
            let url = 'verify/'+token;
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: url
                }).then((response) => {
                    commit('SET_VERIFICATION_ERROR',response.data);
                    resolve(response.data)
                }).catch((error) => {
                    reject(error)
                })
            })
        }
    },
    getters: {
        getConnectedUser : () => {
            let user = localStorage.getItem("user");
            return (user)? JSON.parse(user):undefined;
        }
    }
};
